import * as React from 'react'

import moment from 'moment'

import { observer } from 'mobx-react'

import Form from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import TimePicker from 'modules/core/components/Inputs/TimePicker'
import PanesHeader from 'modules/core/components/PanesHeader'
import { PanesPad } from 'modules/core/components/PanesPad'
import i18n from 'modules/core/lib/i18n'

import ClockPictureForm from 'modules/employees/lib/forms/ClockPicture'
import type ClockPicture from 'modules/employees/store/models/ClockPicture'

interface Props {
  clockPicture: ClockPicture
  employeeFullName: string
}

const InfoForm = ({ employeeFullName, clockPicture }: Props) => {
  const form = React.useRef(
    new ClockPictureForm({
      employee_name: employeeFullName,
      clocked_date: moment.utc(clockPicture.attributes.clock_time).format('ll'),
      clock_time: moment.utc(clockPicture.attributes.clock_time).format('HH:mm'),
      status: clockPicture.status,
    })
  ).current

  const readOnly = true

  return (
    <PanesPad>
      <PanesHeader
        illustration="group"
        title={i18n.t('time_tracking.settings.face_recognition.clock_picture_modal.title')}
        description={i18n.t(
          'time_tracking.settings.face_recognition.clock_picture_modal.description'
        )}
      />
      <Form>
        <FormRow>
          <Text
            label={i18n.t(
              'time_tracking.settings.face_recognition.clock_picture_modal.employee_name'
            )}
            field={form.get('employee_name')}
            readonly={readOnly}
          />
        </FormRow>
        <FormRow>
          <Text
            label={i18n.t('time_tracking.settings.face_recognition.clock_picture_modal.date')}
            field={form.get('clocked_date')}
            readonly={readOnly}
          />
        </FormRow>
        <FormRow>
          <TimePicker
            label={i18n.t('time_tracking.settings.face_recognition.clock_picture_modal.time')}
            field={form.get('clock_time')}
            readonly={readOnly}
          />
        </FormRow>
        <FormRow>
          <Text
            label={i18n.t(
              'time_tracking.settings.face_recognition.clock_picture_modal.record_time'
            )}
            field={form.get('status')}
            readonly={readOnly}
          />
        </FormRow>
      </Form>
    </PanesPad>
  )
}

export default observer(InfoForm)
